type Props = {
	name: string;
	content: string;
};

export function InputLabel({ name, content }: Props) {
	return (
		<label
			id={`${name}-label`}
			htmlFor={name}
			style={{
				fontSize: 13,
				fontWeight: 500,
				color: "var(--content-secondary)",
			}}
		>
			{content}
		</label>
	);
}
